export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const WEBSOCKET_ENDPOINT = import.meta.env.VITE_WEBSOCKET_ENDPOINT;

// Neural Engagement Score Tiers are now fetched dynamically from the backend.
// See stores/app.js for the state and fetching logic.
